import { useAppDispatch } from "app.hook";
import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ORDER_VIEW_ROUTE } from "shared/constants/routes";
import { setActiveMenu, setLoading } from "states/global-value/global-value.slice";
import { getOrdersAPI } from "states/order/order.api";
import { IOrderModel } from "states/order/order.models";
import moment from "moment-timezone";
import { OrderTable } from "./style/order-style";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { formatMoney } from "shared/plugins/string-helper";
import Pagination from "shared/components/pagination/pagination";
import { useDebouncedCallback } from "use-debounce/lib";
import { PagedResult } from "states/paged-result-model";

const OrderPage: FC = (props) => {
  const [model, setModel] = useState<PagedResult<IOrderModel>>({} as PagedResult<IOrderModel>);
  const dispatch = useAppDispatch();
  const [currentPage, setPage] = useState<number>(1);
  const getOrders = async () => {
    dispatch(setLoading(true));
    let result = (await getOrdersAPI(currentPage));
    setModel(result.data);
    dispatch(setLoading(false));
  }
  const handleSearch = useDebouncedCallback(() => {
    getOrders();
  }, 500);
  useEffect(() => {
    handleSearch.callback();
  }, [currentPage])
  useEffect(() => {
    document.title = "Order";
    dispatch(setActiveMenu("order"));
  }, [])
  return (
    <>
      <OrderTable>
        <table>
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Order Date Time</th>
              <th>Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {model?.results?.map((m) => (
              <tr key={m.id}>
                <td>
                  <Link to={`${ORDER_VIEW_ROUTE}/${m.id}`}>{m.orderNumber}</Link>
                </td>
                <td>
                  {m.requestPickupTime ?
                    moment(m.requestPickupTime).tz(m.branch.ianaTimeZone).format(momentDateTimeFormat()) :
                    moment(m.creationTime).tz(m.branch.ianaTimeZone).format(momentDateTimeFormat())
                  }
                </td>
                <td>
                  {formatMoney(m.totalAmount, 2, ".", ",", "$")}
                </td>
                <td>
                  {m.paymentDone ? "Paid" : "Pending"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={model?.currentPage}
          totalPageCount={model?.totalPageCount}
          totalItemCount={model?.totalItemCount}
          onChange={(value) => {
            setPage(value);
          }}
        />
      </OrderTable>
    </>
  );
};

export default OrderPage;
